import Node from './node';

export default class DataTable extends Node {
  clone() {
    return new DataTable(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
